module.exports = __webpack_public_path__ + "static/media/009-dental.961b1f88.svg";